import { StorageWrapper } from "@common-services/storage";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";


import { Settings } from "@common/types/interfaces";
import { setErrorState, setTheme } from "./WhatsAppReducer";
interface State {
  isToggleableNavOpen: boolean;
  isInviteModalOpen: boolean;
  calendarViewOpen: boolean;
  formState: string,
  isEmojiPickerOpen: boolean;
  menuActiveGroupId: string
  isMobileMenuOpen: boolean,
  drawerIsOpen: boolean,
  devices: any[],
  isSocketModalOpen: boolean,
  isHowToScanQrModalOpen: boolean,
  newTabBoardIsOpen: boolean,
  newTabTimerShown: boolean,
  startChatWithPhoneNumberOpen: boolean,
  setNewStatusPopupOpen: boolean,
  displayedNewNotifications: string[],
  staleSessionId?: string;
  newSessionRequested?: boolean;
  settings?: Settings;
  viewMonthStart?: Date;
}

const initialState: State = {
  isToggleableNavOpen: true,
  isInviteModalOpen: false,
  calendarViewOpen: false,
  formState: "",
  isEmojiPickerOpen: false,
  menuActiveGroupId: "",
  isMobileMenuOpen: false,
  drawerIsOpen: true,
  devices: [],
  isSocketModalOpen: false,
  isHowToScanQrModalOpen: false,
  newTabBoardIsOpen: false,
  newTabTimerShown: false,
  displayedNewNotifications: [],
  startChatWithPhoneNumberOpen: false,
  setNewStatusPopupOpen: false,
  staleSessionId: null,
  settings: undefined,
  viewMonthStart: undefined,
};

const mainSlice = createSlice({
  name: "mainSlice",
  initialState,
  reducers: {
    setStaleSessionId(state, action: PayloadAction<string>) {
      state.staleSessionId = action.payload;
      state.newSessionRequested = true;
    },
    handleToggleNav(state, { type, payload }: PayloadAction<boolean>) {
      state.isToggleableNavOpen = payload;
    },
    inviteModalOpen(state, { type, payload }: PayloadAction<boolean>) {
      state.isInviteModalOpen = payload;
    },
    toggleCalendarView(
      state,
      action: PayloadAction<boolean | undefined>
    ) {
      state.calendarViewOpen = action.payload ?? !state.calendarViewOpen;
    },
    closeCalendarView(
      state,
      action: PayloadAction<boolean | undefined>
    ) {
      state.calendarViewOpen = false;
    },
    setFormState(state, action: PayloadAction<any>) {
      state.formState = action.payload
    },
    setDevices(state, action: PayloadAction<any>) {
      state.devices = action.payload
    },
    toggleGroupMenu(state, action: PayloadAction<string>) {
      state.menuActiveGroupId = action.payload
    },
    toggleMobileMenu(state, action: PayloadAction<boolean>) {
      state.isMobileMenuOpen = action.payload
    },
    setDrawerToggle(state, action: PayloadAction<boolean>) {
      state.drawerIsOpen = action.payload
    },
    toggleSocketModal: (state, action: PayloadAction<boolean>) => {
      state.isSocketModalOpen = action.payload;
    },
    toggleHowToScanQrModal: (state, action: PayloadAction<boolean>) => {
      state.isHowToScanQrModalOpen = action.payload;
    },
    toggleNewTabBoardWindow: (state, action: PayloadAction<boolean>) => {
      state.newTabBoardIsOpen = action.payload;
    },
    toggleNewTabTimer: (state, action: PayloadAction<boolean>) => {
      state.newTabTimerShown = action.payload;
    },
    setDisplayedNewNotifications(state, action: PayloadAction<string>) {
      state.displayedNewNotifications = [...state.displayedNewNotifications, action.payload];
    },
    resetDisplayedNewNotifications(state) {
      state.displayedNewNotifications = [];
    },
    setStartChatWithPhoneNumberOpen(state, action: PayloadAction<boolean>) {
      state.startChatWithPhoneNumberOpen = action.payload;
    },
    setSetNewStatusPopupOpen(state, action: PayloadAction<boolean>) {
      state.setNewStatusPopupOpen = action.payload;
    },
    setSettings: (state, action: PayloadAction<Settings>) => {
      state.settings = action.payload;
    },
    setViewMonthStart: (state, action: PayloadAction<Date>) => {
      state.viewMonthStart = action.payload;
    },
  },
});


export const initStorageWrapper = createAsyncThunk("initStorageWrapper", async (_, thunkApi) => {
  const dispatch = thunkApi.dispatch;
  const storageWrapper: StorageWrapper = new StorageWrapper();
  storageWrapper.on("storage-error", (error) => {
    console.log(error);
    dispatch(setErrorState(true));
  });
});



export const mainSliceActions = mainSlice.actions;

export const {
  toggleSocketModal,
  toggleHowToScanQrModal,
  toggleNewTabBoardWindow,
  toggleNewTabTimer,
  setDisplayedNewNotifications,
  resetDisplayedNewNotifications,
  setStartChatWithPhoneNumberOpen,
  setSetNewStatusPopupOpen,
  setSettings,
} = mainSlice.actions;
export default mainSlice.reducer;
